<template>
  <v-card class="pa-4" flat>
    <qr-code-make-nfc
      hidden
      ref="qrCanvas"
      v-model="qrDesign"
      :identifier="identifier"
      :file.sync="qrSvgDataUrl"
      @save="qrDesign = $event"
    />

    <custom-popup
      v-model="showCart"
      :cons="{ title: 'کارت NFC' }"
      max-width="500"
      class="nfc-card-popup"
      :reloadable="true"
      :persistent="true"
      @reload="fetchData"
    >
      <v-card class="rounded-0" outlined flat>
        <div class="pa-6 overflow-hidden text-center">
          <div
            v-if="
              selectedInfo.cards &&
              selectedInfo.cards.length > 0
            "
            class="d-flex flex-wrap justify-center gap-4 pa-4"
          >
            <div
              v-for="(card, index) in selectedInfo.cards"
              :key="index"
              class="flip-card w-100"
              @click="toggleFlip(index)"
              @touchstart="toggleFlip(index)"
              v-touch="{
                left: () => swipe('Left', index),
                right: () => swipe('Right', index),
              }"
            >
          <span color="primary" class="ma-2">
            <template v-if="card?.id">شناسه: {{ card.id }}</template>
            <template v-if="card?.id && card?.title"> / </template>
            <template v-if="card?.title">{{ card.title }}</template>
            <template v-if="card?.color"> ({{ card.color }})</template>
          </span>
              <div class="flip-card-inner" :class="{ flipped: flipped[index] }">
                <div class="flip-card-front">
                  <div class="image-container">
                    <img :src="card.front_image" class="card-img" />
                  </div>
                </div>
                <div class="flip-card-back">
                  <div class="image-container">
                    <img :src="card.back_image" class="card-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- اگر رایگان باشد -->
          <div v-else-if="selectedInfo?.is_free === 1" class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-card-off</v-icon>
            <p class="mt-4 grey--text text--darken-1 text-subtitle-1">
              کارت NFC فقط برای سفارش‌های اختصاصی قابل مشاهده است.
            </p>
            <v-card-actions
              class="justify-center pb-4"
              v-if="selectedInfo.short_link"
            >
              <v-btn
                color="primary"
                outlined
                small
                @click="copyInClipboard(selectedInfo.short_link)"
              >
                <v-icon left small>mdi-content-copy</v-icon>
                کپی لینک کوتاه
              </v-btn>
            </v-card-actions>
          </div>

          <!-- اگر هیچ کارتی نبود -->
          <div v-else class="text-center py-8 text-subtitle-1 grey--text">
            هیچ کارتی برای نمایش وجود ندارد.
          </div>
        </div>
      </v-card>
    </custom-popup>
    
    <vue-table
      :data="data"
      :headers="headers"
      :loading.sync="loading"
      @change="onPagination"
    >
    
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="2" md="3">
            <v-select
              v-model="props.length"
              :items="perPage"
              class="rounded-lg"
              dense
              hide-details
              label="تعداد"
              outlined
            />
          </v-col>
          <v-col class="pa-2" cols="12" lg="4" md="4">
            <v-text-field
              v-model="props.search"
              append-icon="mdi-magnify"
              class="rounded-lg"
              clearable
              dense
              hide-details
              label="جستجو"
              outlined
            />
          </v-col>
          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-autocomplete
              v-model="props.status"
              append-icon="mdi-list-status"
              class="rounded-lg"
              clearable
              :items="items"
              item-text="text"
              @change="changestatus"
              item-value="value"
              dense
              :no-data-text="
                items.length === 0
                  ? 'هیچ وضعیتی وجود ندارد'
                  : 'در حال بارگذاری...'
              "
              hide-details
              label="وضعیت"
              outlined
              ><template v-slot:selection="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small color="primary">{{ item.icon }}</v-icon>
                {{ item.text }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="pa-2" cols="12" lg="3" md="3">
            <v-autocomplete
              v-model="props.type"
              append-icon="mdi-cash-multiple"
              class="rounded-lg"
              clearable
              :items="itemsType"
              item-text="text"
              @change="changeType"
              item-value="value"
              dense
              :no-data-text="
                items.length === 0 ? 'هیچ نوع وجود ندارد' : 'در حال بارگذاری...'
              "
              hide-details
              label="نوع"
              outlined
            >
              <template v-slot:selection="{ item }">
                <v-icon left small> {{ item?.icon }}</v-icon>
                <span>{{ item?.text }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-icon left small> {{ item?.icon }}</v-icon>
                <span>{{ item?.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- فیلتر نحوه تحویل -->
<v-col class="pa-2" cols="12" lg="2" md="3">
  <v-autocomplete
    v-model="props.delivery_methode"
    append-icon="mdi-truck-delivery"
    class="rounded-lg"
    clearable
    :items="itemsDelivery"
    item-text="text"
    @change="changeDelivery"
    item-value="value"
    dense
    hide-details
    label="نحوه تحویل"
    outlined
  >
    <template v-slot:selection="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
    <template v-slot:item="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
  </v-autocomplete>
</v-col>

<!-- فیلتر مرتب‌سازی -->
<v-col class="pa-2" cols="12" lg="2" md="3">
  <v-select
    v-model="props.dir"
    :items="itemsSort"
    item-text="text"
    item-value="value"
    @change="changeSort"
    class="rounded-lg"
    dense
    hide-details
    label="مرتب‌سازی"
    outlined
  >
    <template v-slot:selection="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      <span class="text-truncate" style="max-width: 100px;">{{ item.text }}</span>
    </template>
    <template v-slot:item="{ item }">
      <v-icon left small color="primary">{{ item.icon }}</v-icon>
      {{ item.text }}
    </template>
  </v-select>
</v-col>

        </v-row>
      </template>

      <template v-slot:index="{ item }">
        {{ persian(item.index + 1 + (data.current_page - 1) * data.per_page) }}
      </template>

      <template v-slot:nfc_cart="{ item }">
        <v-btn
          color="primary"
          link
          text
          @click="
            () => {
              openNfcCard(item);
            }
          "
        >
          {{ persian(item?.nfc_cart?.id) || "" }}
          <v-icon
            class="ms-2"
            @click.stop="copyInClipboard(item?.nfc_cart?.id)"
            >mdi-content-copy</v-icon
          >
        </v-btn>
      </template>

      <template v-slot:user_fullname="{ item }">
        {{ item?.user?.name + " " + item?.user?.lastName }}
      </template>
      <template v-slot:type="{ item }">
        <v-chip :color="typeText(item?.type)?.color" small>
          <v-icon left :color="typeText(item?.type)?.color" x-small>
            {{ typeText(item?.type)?.icon }}
          </v-icon>
          {{ typeText(item?.type)?.text }}
        </v-chip>
      </template>
      <template v-slot:province_city="{ item }">
        {{
          item.province === null
            ? "تحویل از شرکت"
            : item?.province + " / " + item?.city
        }}
      </template>
      <template v-slot:address="{ item }">
        <v-tooltip bottom color="light-blue-lighten-4">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="text-truncate">{{
              item?.address === null || item?.address?.trim() === ""
                ? "---"
                : item.address
            }}</span>
          </template>
          <span>{{
            item?.address === null || item?.address?.trim() === ""
              ? "---"
              : item.address
          }}</span>
        </v-tooltip>
      </template>
      <template v-slot:count="{ item }">
        {{ getTotalQuantity(item) }}
      </template>

      <template v-slot:status="{ item }">
        <v-chip :color="sateText(item?.status)?.color" small>
          <v-icon left :color="sateText(item?.status)?.color" x-small>
            {{ sateText(item?.status)?.icon }}
          </v-icon>
          {{ sateText(item?.status)?.text }}
        </v-chip>
      </template>
      <template v-slot:created_at="{ item }">
        <v-tooltip bottom color="light-blue-lighten-4">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="date-truncate">
              {{ toJalaliDateTime(item?.created_at) || "-" }}
            </span>
          </template>
          <span>
            {{ toJalaliDateTime(item?.created_at) || "-" }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:qr_id="{ item }">
        <v-btn
          color="primary"
          link
          text
          @click.stop="copyInClipboard(item?.qr_id)"
        >
          {{ persian(item.qr_id) || "-" }}
          <v-icon class="ms-2" @click.stop="copyInClipboard(item?.qr_id)"
            >mdi-content-copy</v-icon
          >
        </v-btn>
      </template>
      <template v-slot:postal_code="{ item }">
        {{ persian(item?.postal_code) || "-" }}
      </template>
      <template v-slot:manage="{ item }">
        <manage-button
          :data="item"
          :meta="getMetaButtons(item)"
          v-if="item.status !== 'canceled'"
        />
        <div v-if="item.status === 'canceled'">
          <v-icon left small>mdi-close</v-icon>
        </div>
      </template>
      <!-- حالت خالی بودن جدول -->
      <template v-slot:empty>
        <div class="empty-state-wrapper">
          <v-icon size="80" color="grey lighten-2"
            >mdi-inbox-remove-outline</v-icon
          >

          <h3 class="text-h6 grey--text text--darken-2 mt-4 font-weight-bold">
            هیچ سفارشی یافت نشد!
          </h3>

          <p class="grey--text text--darken-1 mt-2 text-body-1">
            <template v-if="hasActiveFilters">
              با جستجو یا فیلترهای انتخابی شما نتیجه‌ای پیدا نشد.
            </template>
            <template v-else>
              تا کنون هیچ سفارش NFC در سیستم ثبت نشده است.
            </template>
          </p>

          <!-- دکمه پاک کردن فیلترها در صورتی که فیلتری فعال باشد -->
          <v-btn
            v-if="hasActiveFilters"
            color="primary"
            outlined
            class="mt-4 rounded-lg"
            @click="clearFilters"
          >
            <v-icon left>mdi-filter-remove-outline</v-icon>
            پاک کردن فیلترها
          </v-btn>
        </div>
      </template>
    </vue-table>
  </v-card>
</template>

<script>
import manageButton from "@/view/pages/button.vue";
import moment from "moment-jalaali";
import qrCodeMakeNfc from "@/view/pages/qrland/qrCodeStyle/qrCodeMakeNfc.vue";

export default {
  name: "nfcOrdersList",
  components: {
    manageButton,
    qrCodeMakeNfc,
  },
  filters: {
    typeFilter(value) {
      switch (value) {
        case "free":
          return "رایگان";
        case "special":
          return "اختصاصی";
        default:
          return value;
      }
    },
  },

  data() {
    return {
      loading: false,
      showCart: false,
      selectedInfo: {},
      tableProps: {
        page: 1,
        search: "",
        length: 10,
        to: 1,
         status: null, 
        type: null,
        delivery_methode: null,
        column: "updated_at",  
        dir: "desc",
      },
       itemsDelivery: [
        { text: "همه", value: null, icon: "mdi-filter" },
        { text: "تحویل از شرکت", value: "company", icon: "mdi-domain" },
        { text: "پست", value: "post", icon: "mdi-truck" },
      ],
      itemsSort: [
        { text: "جدیدترین سفارش", value: "desc", icon: "mdi-sort-clock-descending-outline" },
        { text: "قدیمی‌ترین سفارش", value: "asc", icon: "mdi-sort-clock-ascending-outline" },
      ],
      qrSvgDataUrl: null,
      qrDesign: null,
      qrId: null,
      identifier: null,
      itemsType: [
        { text: "همه", value: null, icon: "mdi-filter" },
        { text: "رایگان", value: "free", icon: "mdi-gift" },
        { text: "اختصاصی", value: "special", icon: "mdi-cash-multiple" },
      ],
      items: [
        { text: "همه", value: null, icon: "mdi-filter" },
        { text: "ارسال شده", value: "shipped", icon: "mdi-truck" },
        { text: "پرداخت شده", value: "paid", icon: "mdi-cash-check" },
        { text: "تحویل شده", value: "delivered", icon: "mdi-check" },
        { text: "رد شده", value: "canceled", icon: "mdi-close" },
      ],
      flipped: {},
      data: {},
      imageCache: {},
      headers: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        // {
        //   value: "user_id",
        //   text: "شناسه کاربر",
        //   align: "center",
        //   sortable: false,
        // },
        {
          value: "user_fullname",
          text: "نام/ نام خانوادگی",
          align: "center",
          sortable: false,
        },
        {
          value: "qr_id",
          text: "شناسه کیوآر",
          align: "center",
          sortable: false,
        },
        { value: "type", text: "نوع", align: "center", sortable: false },
        // { value: "province", text: "استان", align: "center", sortable: false },
        {
          value: "province_city",
          text: "استان/ شهر",
          align: "center",
          sortable: false,
        },
        { value: "address", text: "آدرس", align: "center", sortable: false },
        {
          value: "postal_code",
          text: "کد پستی",
          align: "center",
          sortable: false,
        },
        {
          value: "nfc_cart",
          text: "کارت NFC",
          align: "center",
          sortable: false,
        },
        { value: "status", text: "وضعیت", align: "center", sortable: false },
        {
          value: "created_at",
          text: "زمان ثبت سفارش",
          align: "center",
          sortable: false,
        },
        {
          value: "count",
          text: "تعداد",
          align: "center",
          sortable: false,
        },
        { value: "manage", text: "مدیریت", align: "center", sortable: false },
      ],
      metaButtons: {
        buttons: [
          {
            text: "تغییر وضعیت",
            color: "success",
            label: "تغییر وضعیت",
            icon: "exchange-alt",
            class: "btn-accept rounded-pill",
            action: (data) => this.action(data, "change_status"),
          },
          {
            text: "رد کردن",
            label: "رد کردن",
            icon: "ban",
            class: "btn-outline-danger",
            action: (data) => this.action(data, "canceled"),
          },
        ],
      },
    };
  },
  computed: {
    hasActiveFilters() {
      return (
        (this.tableProps.search && this.tableProps.search.trim() !== "") ||
        this.tableProps.status !== null ||
        this.tableProps.type !== null ||
        this.tableProps.delivery_methode !== null 
      );
    },
  },
  mounted() {
    this.fetchData();
  },

  methods: {
    clearFilters() {
      this.tableProps.search = "";
      this.tableProps.status = null;
      this.tableProps.type = null;
      this.tableProps.page = 1;
      this.tableProps.delivery_methode = null; 
      this.tableProps.sort_dir = "desc";
      this.fetchData();
    },
     changeDelivery(value) {
      this.tableProps.delivery_methode = value === "" ? null : value;
      this.tableProps.page = 1;
      this.fetchData();
    },
     changeSort(value) {
      this.tableProps.dir = value;
      this.tableProps.page = 1;
      this.fetchData();
    },
    swipe(dir, index) {
      if (dir === "Left" && this.isFlipped(index)) {
        this.$set(this.flipped, index, false);
      } else if (dir === "Right" && !this.isFlipped(index)) {
        this.$set(this.flipped, index, true);
      }
    },
    isFlipped(index) {
      return this.flipped[index];
    },
    toggleFlip(index) {
      this.$set(this.flipped, index, !this.flipped[index]);
    },
    getTotalQuantity(item) {
      if (item.type === "free") {
        return item.count || 0;
      }

      if (item.type === "special" && item.orders) {
        try {
          const orders = JSON.parse(item.orders);
          return orders[0].quantity || 0;
        } catch (e) {
          return 0;
        }
      }

      return 0;
    },
    getImageOrientation(imageUrl) {
      if (this.imageCache[imageUrl]) return this.imageCache[imageUrl];

      const img = new Image();
      img.crossOrigin = "anonymous";
      if (img.complete) {
        const info = {
          width: img.naturalWidth,
          height: img.naturalHeight,
          orientation:
            img.naturalWidth > img.naturalHeight ? "horizontal" : "vertical",
          aspectRatio: img.naturalWidth / img.naturalHeight,
        };
        this.imageCache[imageUrl] = info;
        return info;
      }

      img.onload = () => {
        const info = {
          /* same as above */
        };
        this.imageCache[imageUrl] = info;
      };
      img.onerror = () => {
        /* fallback */
      };
      img.src = imageUrl;

      return (
        this.imageCache[imageUrl] ||
        {
          /* fallback */
        }
      );
    },
    openNfcCard(item) {
      let cards = [];
      if (item.orders) {
        try {
          const orders = item.orders||[];
          console.log(orders,"orders",item.orders,"item.orders" );
          orders.forEach((order) => {
            // const frontInfo = this.getImageOrientation(orders[0].front_image);
            // const orientation = "vertical";
            cards.push({
              front_image: order.front_image,
              back_image: order.back_image,
              title: order?.title,
              id: order?.id,
              color: order?.color
              // orientation,
              // frontAspect: frontInfo.aspectRatio,
            });
          });
        } catch (e) {
          console.error("خطا در پارز orders:", e);
        }
        } else if (item.nfc_cart) {
      // } else if (item.type === "free" && item.nfc_cart) {
        // const frontInfo = this.getImageOrientation(item.nfc_cart.front_image);
        // const orientation = item.nfc_cart.orientation;
        cards.push({
          front_image: item.nfc_cart.front_image,
          back_image: item.nfc_cart.back_image,
          title: item.nfc_cart.title,
          id: item.nfc_cart.id,
          color: item.nfc_cart.color
          // orientation,
          // frontAspect: frontInfo.aspectRatio,
        });
      }

      this.selectedInfo = {
        ...item,
        cards,
        is_free: item.type === "free" ? 1 : 0,
      };

      this.showCart = true;
      this.flipped = {};
    },
    // openNfcCard(item) {
    //   let cards = [];
    //   //special card
    //   if (item.type === "special") {
    //     try {
    //       const orders = JSON.parse(item.orders || "[]");
    //       orders.forEach((order) => {
    //         cards.push({
    //           front_image: order.front_image,
    //           back_image: order.back_image,
    //           orientation: "vertical",
    //         }); 
    //       });
    //     } catch (e) {
    //       console.error("خطا در پارز orders:", e);
    //     }
    //   } else if (item.type === "free" && item.nfc_cart) {
    //     //free card
    //     cards.push({
    //       front_image: item.nfc_cart.front_image,
    //       back_image: item.nfc_cart.back_image,
    //       orientation: item.nfc_cart.orientation || "vertical",
    //     });
    //   }

    //   this.selectedInfo = {
    //     ...item,
    //     cards,
    //     is_free: item.type === "free" ? 1 : 0,
    //   };

    //   this.showCart = !this.showCart;
    //   this.flipped = {};
    // },
    getMetaButtons(item) {
      const statusMap = {
        paid: "shipped",
        shipped: "delivered",
        delivered: "delivered",
        canceled: "canceled",
      };
      const nextStatus = statusMap[item.status] || "canceled";
      const nextStatusText = this.sateTextmeta(nextStatus);
      return {
        buttons: [
          {
            text: nextStatusText.text,
            color: "success",
            label: `تغییر وضعیت به ${nextStatusText.text}`,
            icon: nextStatusText.icon,
            class: "btn-accept rounded-pill",
            action: (data) => this.action(data, "change_status"),
          },
          {
            text: "رد کردن",
            label: "رد کردن",
            icon: "ban",
            class: "btn-outline-danger",
            action: (data) => this.action(data, "canceled"),
          },
        ],
      };
    },
    action(data, type) {
      switch (type) {
        case "change_status":
          this.StatusCheck(data);
          break;
        case "canceled":
          this.canceled(data);
        default:
          break;
      }
    },
    onPagination(e) {
      if (e !== this.tableProps.page) {
        this.tableProps.page = e.page;
        this.tableProps.length = e.length;
        this.tableProps.search = e.search;
        this.$nextTick(() => {
          this.fetchData();
        });
      }
    },
    typeText(value) {
      switch (value) {
        case "free":
          return { text: "رایگان", color: "teal-lighten-3", icon: "mdi-gift" };
        case "special":
          return {
            text: "اختصاصی",
            color: "light-blue-lighten-3",
            icon: "mdi-cash-multiple",
          };
        default:
          return { text: value, color: "grey-lighten-2", icon: "mdi-cash" };
      }
    },
    sateText(state) {
      switch (state) {
        case "shipped":
          return {
            text: "ارسال شده",
            color: "teal-lighten-4",
            icon: "mdi-truck",
          };
        case "paid":
          return {
            text: "پرداخت شده",
            color: "amber-lighten-3",
            icon: "mdi-cash-check",
          };
        case "delivered":
          return {
            text: "تحویل شده",
            color: "cyan-lighten-4",
            icon: "mdi-check",
          };
        case "canceled":
          return { text: "رد شده", color: "red-lighten-4", icon: "mdi-close" };
        default:
          return {
            text: state,
            color: "grey-lighten-3",
            icon: "mdi-help-circle",
          };
      }
    },
    sateTextmeta(state) {
      switch (state) {
        case "shipped":
          return {
            text: "ارسال شده",
            color: "teal-lighten-4",
            icon: "truck",
          };
        case "paid":
          return {
            text: "پرداخت شده",
            color: "amber-lighten-3",
            icon: "cash-check",
          };
        case "delivered":
          return {
            text: "تحویل شده",
            color: "cyan-lighten-4",
            icon: "check",
          };
        case "canceled":
          return {
            text: "رد شده",
            color: "red-lighten-4",
            icon: "fa-ban",
          };
        default:
          return {
            text: state,
            color: "grey-lighten-3",
            icon: "help-circle",
          };
      }
    },
    StatusCheck(item) {
      this.loading = true;
      const statusMap = {
        shipped: "delivered",
        paid: "shipped",
        delivered: "delivered",
        canceled: "canceled",
      };
      const status = statusMap[item.status] || "canceled";
      if (!status) return;
      this.$api
        .post("/admin/ChangeStatusOrder", {
          status: status,
          ids: [item.id],
          type: item.type,
        })
        .then(({ data }) => {
          this.loading = false;

          const t = this.sateText(status).text;
          this.$toast.success(`سفارش با موفقیت تغییر وضعیت به ${t} یافت.`);
          this.fetchData();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(" خطا در تغییر وضعیت");
          console.error(error);
        })
        .finally(() => {});
    },
    canceled(data) {
      this.loading = true;
      this.qrId = data.qr_id;
      this.$api
        .post("/admin/ChangeStatusOrder", {
          status: "canceled",
          ids: [data.id],
          type: data.type,
        })
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("سفارش با موفقیت رد شد");
          this.identifier = data.data.code;

          this.generateQr(
            this.qrId,
            this.identifier,
            data.data.qr.domain.name,
            data.data.qr.type,
            data.data.qr.identifier,
          );
          this.fetchData();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error("خطا در رد کردن سفارش");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData(params = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/admin/index-nfc", { params })
        .then(({ data }) => {
          
          this.data = data;
        })
        .catch((error) => {
          this.$toast.error("خطا در بارگذاری داده‌ها");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changestatus(value) {
      this.tableProps.status = value === "" ? null : value;
      this.fetchData();
    },
    changeType(value) {
      this.tableProps.type = value === "" ? null : value;
      this.fetchData();
    },
    copyInClipboard(input) {
      navigator.clipboard.writeText(input);
      this.$toast.success("کپی شد.");
    },
    toJalaliDateTime(gregorianDate) {
      try {
        return moment(gregorianDate)
          .locale("fa")
          .format("jYYYY/jMM/jDD HH:mm:ss");
      } catch (error) {
        console.error("Error converting date:", error);
        return "-";
      }
    },
    types(value) {
      switch (value) {
        case "free":
          return "رایگان";
        case "special":
          return "اختصاصی";
        default:
          return value;
      }
    }, //this.qrId, this.identifier,data.data.domain.name,data.data.qr.type
    async generateQr(qrId, identifier, domain, type, identifierorg) {
      const selectedId = qrId || null;
      if (!selectedId || !identifier) {
        return;
      }
      try {
        await this.updateQrWithRandomDesign();
        await this.$nextTick();

        // Wait for NewqrSvgDataUrl to be updated
        await new Promise((resolve) => {
          const checkSvg = () => {
            if (
              this.qrSvgDataUrl !== "" &&
              this.qrSvgDataUrl !== "https://qr2.in/"
            ) {
              resolve();
            } else {
              setTimeout(checkSvg(), 20000);
            }
          };
          checkSvg();
        });

        const data = new FormData();
        data.append("domain", domain);
        data.append("identifier", identifierorg);
        data.append("type", type);
        data.append("qr_id", this.qrId);
        data.append("image", this.qrSvgDataUrl);
        data.append("qr", JSON.stringify(this.qrDesign));

        data.append("_method", "PUT");
        const res = await this.$api.post("/v1/testQr/update", data, {
          // headers: { "Content-Type": "multipart/form-data" },
          headers: { "Content-Type": "application/from-data" },
        });

        this.$toast.success("کیوآر با موفقیت بازنشانی شد.");
        //  await this.fetch();
      } catch (err) {
        this.$toast.error("خطا در به‌روزرسانی کیوآر!");
      } finally {
        this.qrDesign = null;
        this.qrSvgDataUrl = null;

        // this.imageLoading = false;
      }
    },
    async updateQrWithRandomDesign() {
      this.qrDesign = {
        width: 300,
        height: 300,
        data: `https://qr2.in/${this.identifier}`,
        margin: 5,
        qrOptions: {
          typeNumber: 0,
          mode: "Byte",
          errorCorrectionLevel: "H",
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0,
        },
        dotsOptions: {
          type: "extra-rounded",
          color: "#6a1a4c",
          gradient: {
            type: "linear",
            rotation: 0,
            colorStops: [
              { offset: 0, color: "#933490" },
              { offset: 1, color: "#933490" },
            ],
          },
        },
        backgroundOptions: { color: "#FFFFFFFF" },
        image: null,
        dotsOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#6a1a4c",
            color2: "#6a1a4c",
            rotation: "0",
          },
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          color: "#690a70",
        },
        cornersSquareOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        cornersDotOptions: { type: "", color: "#b00cab" },
        cornersDotOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#000000",
            color2: "#000000",
            rotation: "0",
          },
        },
        backgroundOptionsHelper: {
          colorType: { single: true, gradient: false },
          gradient: {
            linear: true,
            radial: false,
            color1: "#ffffff",
            color2: "#ffffff",
            rotation: "0",
          },
        },
      };
      await this.$nextTick();
      // if (this.$refs.qrCanvas && !!this.identifier) {

      await this.$refs.qrCanvas.appendCanvas(
        `https://qr2.in/${this.identifier}`,
      );
      // }
      await this.$nextTick();
      await new Promise((resolve) => {
        let retryCount = 0;
        const maxRetries = 2;

        const checkSvg = () => {
          if (
            this.qrSvgDataUrl &&
            this.qrSvgDataUrl !== "" &&
            !this.qrSvgDataUrl.startsWith("https://qr2.in/")
          ) {
            if (this.qrSvgDataUrl.startsWith("data:image/svg+xml")) {
              const base64 = this.qrSvgDataUrl.split(",")[1];
              const decoded = atob(base64);
              if (!decoded.includes(this.identifier)) {
                console.error("Identifier NOT FOUND in SVG!", this.identifier);
                if (retryCount < maxRetries && this.$refs.qrCanvas) {
                  retryCount++;
                  this.$refs.qrCanvas.getDataUrl();
                  setTimeout(checkSvg, 1000);
                  return;
                }
              } else {
                console.log("Identifier FOUND in SVG!", this.identifier);
              }
            }
            resolve();
          } else {
            setTimeout(checkSvg, 200);
          }
        };
        checkSvg();
      });
      await this.$nextTick();
    },
  },
};
</script>
<style scoped>
/* ================================================================= */
/* 1. سایر استایل‌های عمومی (text-truncate, رنگ‌ها و ...)         */
/* ================================================================= */
.text-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  width: 100%;
  box-sizing: border-box;
  vertical-align: middle;
}

.date-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40px;
  width: 100%;
  font-size: 9px !important;
  box-sizing: border-box;
  vertical-align: middle;
}

/* رنگ‌های چیپ (استفاده در جدول) */
.teal-lighten-3 {
  background-color: #74b8b1 !important;
  color: #fff !important;
}
.light-blue-lighten-3 {
  background-color: #48b0e0 !important;
  color: #fff !important;
}
.grey-lighten-2 {
  background-color: #ffaf7a !important;
  color: #424242 !important;
}
.teal-lighten-4 {
  background-color: #8ccac5 !important;
  color: #fff !important;
}
.amber-lighten-3 {
  background-color: #eebb24 !important;
  color: #424242 !important;
}
.cyan-lighten-4 {
  background-color: #35c9dd !important;
  color: #fff !important;
}
.red-lighten-4 {
  background-color: #f77d89 !important;
  color: #fff !important;
}
.grey-lighten-3 {
  background-color: #f5f5f5 !important;
  color: #424242 !important;
}

/* ================================================================= */
/* 2. پاپ‌آپ NFC (بدون سایه و گوشه گرد)                         */
/* ================================================================= */
.nfc-card-popup .v-dialog {
  box-shadow: none !important;
  border-radius: 0 !important;
}

/* ================================================================= */
/* 3. کارت چرخان (Flip Card) — اصلی‌ترین بخش                     */
/* ================================================================= */
.flip-card {
  background-color: transparent;
  width: 100%;
  max-width: 280px;
  min-width: 100%;
  height: 280px;
  min-height: 280px;
  perspective: 1000px;
  margin: 0 auto;
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
}

/* کانتینر داخلی که می‌چرخه */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.flip-card-inner.flipped {
  transform: rotateY(180deg) !important;
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

/* روی کارت (جلو) */
.flip-card-front {
  z-index: 2;
}

/* پشت کارت (چرخش اولیه) */
.flip-card-back {
  transform: rotateY(180deg);
  z-index: 1;
}

/* کانتینر تصویر داخل هر طرف */
.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #f9f9f9;
  border-radius: 12px;
}

/* تصویر اصلی */
.card-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

/* ================================================================= */
/* 4. افکت hover (زیبا و نرم)                                     */
/* ================================================================= */
.flip-card:hover .flip-card-inner {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
  transition: all 0.3s ease;
}

.flip-card:hover .card-img {
  transform: scale(1.05);
}

/* ================================================================= */
/* 5. ریسپانسیو (موبایل)                                           */
/* ================================================================= */
@media (max-width: 600px) {
  .flip-card {
    max-width: 140px;
    height: 140px;
    min-height: 140px;
  }
}
.empty-state-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background-color: #fafafabb;
  border: 2px dashed #e0e0e027;
  border-radius: 16px;
  margin: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.empty-state-wrapper:hover {
  border-color: #bdbdbd;
}

.empty-state-wrapper p {
  max-width: 400px;
  line-height: 1.6;
}
</style>
